import { useMediaQuery } from '../useMediaQuery';

export const useIsTablet = () => useMediaQuery('(max-width: 1023.98px)');
